import { MESApiService, getMomentTz, spParameter } from "@dexteel/mesf-core";
import { ReadyToCastHeatsResponse } from "../models/catalogs.models";
import { ProcessResponse, Torch } from "../models/torches.models";

const moment = getMomentTz();

export const getTorchesProcess = async ({
  ProcessId = null,
}: {
  ProcessId: number | null;
}) => {
  const apiService = new MESApiService();

  const resp = await apiService.callV2("[CAS].[DEGetTorches]", [
    { name: "ProcessId", value: ProcessId },
  ]);

  if (resp.ok) {
    const data = resp.data as ProcessResponse;

    const process = data.tables[0].rows[0];
    data.tables[0].rows[0] = {
      ...data.tables[0].rows[0],
      LadleOpen: process.LadleOpen
        ? moment.utc(process["LadleOpen"]).toDate()
        : null,
      Arrive: moment.utc(process["Arrive"]).toDate(),
      LadleClose: process.LadleClose
        ? moment.utc(process["LadleClose"]).toDate()
        : null,
      TapTime: process.TapTime ? moment.utc(process["TapTime"]).toDate() : null,
    };
    data.tables[1].rows = data.tables[1].rows.map((row) => {
      return row;
    });

    return {
      ok: true,
      data,
    };
  } else {
    return {
      ok: false,
      message: resp.message,
    };
  }
};

type UpsertProcessDataParams = {
  processId: number;
  field: string;
  value: boolean | string | number | Date | null;
};

export const upsertProcessData = async ({
  processId,
  field,
  value,
}: UpsertProcessDataParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: field, value: value },
    { name: "IsManual", value: true },
  ];

  return await apiService.callV2(
    "[CAS].[UpsertTorchesProcessData]",
    parameters,
  );
};

type UpsertHeatParams = {
  HeatId: number;
  field: string;
  value: any;
};

export const upsertHeat = async ({
  HeatId,
  field,
  value,
}: UpsertHeatParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "HeatId", value: HeatId },
    { name: field, value: value },
  ];

  return await apiService.callV2("[MS].[UpsertHeat]", parameters);
};

export const getHeatsForSelector = async () => {
  const apiService = new MESApiService();

  const resp = await apiService.callV2("[CAS].[GetReadyToCastHeats]", []);
  if (resp.ok) {
    const data = resp.data as ReadyToCastHeatsResponse;
    return {
      ok: true,
      data: data.tables[0].rows,
    };
  } else {
    return {
      ok: false,
      message: resp.message!,
    };
  }
};
type ChangeHeatStatusProps = {
  heatId: number;
  status: string;
};
export const changeCasterHeatStatus = async ({
  heatId,
  status,
}: ChangeHeatStatusProps) => {
  const apiService = new MESApiService();
  const resp = await apiService.callV2("[CAS].[ChangeHeatStatusCommand]", [
    { name: "HeatId", value: heatId },
    { name: "HeatStatusCode", value: status.charAt(0) },
  ]);
  if (resp.ok) {
    const data = resp.data;
    return {
      ok: true,
      data: data.tables[0].rows,
    };
  } else {
    return {
      ok: false,
      message: resp.message!,
    };
  }
};

type UpsertTorchParams = {
  ProcessId: number | null;
  Strand: number;
  ColdLength: number | null;
  HotLength: number | null;
  WeightRounded: number | null;
  WeightOriginal: number | null;
  Undefined: number | null;
  Scrapped: number | null;
  Billets: number | null;
  TotalCuts: number | null;
  IsManual: boolean;
};

export const upsertTorchData = async ({
  ProcessId,
  Strand,
  ColdLength,
  HotLength,
  WeightRounded,
  WeightOriginal,
  Undefined,
  Scrapped,
  Billets,
  TotalCuts,
  IsManual,
}: UpsertTorchParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "Strand", value: Strand },
    { name: "ColdLength", value: ColdLength },
    { name: "HotLength", value: HotLength },
    { name: "WeightRounded", value: WeightRounded },
    { name: "WeightOriginal", value: WeightOriginal },
    { name: "Undefined", value: Undefined },
    { name: "Scrapped", value: Scrapped },
    { name: "Billets", value: Billets },
    { name: "TotalCuts", value: TotalCuts },
    { name: "IsManual", value: IsManual },
  ];

  return await apiService.callV2("[CAS].[UpsertTorchesData]", parameters);
};

export const upsertTorchesData = async ({ torches }: { torches: Torch[] }) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "JsonData", value: JSON.stringify(torches) },
  ];

  return await apiService.callV2("[CAS].[UpsertTorchesFromDE]", parameters);
};

export const deleteTorchData = async ({
  ProcessId,
  Strand,
  HotLength,
}: {
  ProcessId: number | null;
  Strand: number;
  HotLength: number | null;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "Strand", value: Strand },
    { name: "HotLength", value: HotLength },
  ];

  return await apiService.callV2("[CAS].[DeleteTorchesStrand]", parameters);
};

export const readTorchFromPLC = async ({
  ProcessId,
  Strand,
}: {
  ProcessId: number;
  Strand: number;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "Strand", value: Strand },
  ];

  return await apiService.callV2("[RBD].[ReadCASCutsFromPLC]", parameters);
};

export const getLastestProcesses = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessCode", value: "C" }];

  return await apiService.callV2("[RBD].[GetLastestNProcesses]", parameters);
};
